import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="admin-post-form"
export default class extends Controller {
  static targets = [
    'albumSelectField',
    'trackSelectField'
  ]

  selectAlbum = ({ target: { value: albumId } }) => {
    this.trackSelectFieldTargets.forEach((trackSelectField) => {
      const trackAlbumId = trackSelectField.dataset.albumId
      const active = albumId === trackAlbumId
      trackSelectField.disabled = !active
      trackSelectField.dataset.show = active
    })
  }
}
